import { addAllToRecord } from '@ms/yammer-data-support';
import { MessageDeletionOutcome } from '@ms/yammer-graphql';
import { Reducer } from 'redux';

import { DeleteMessageFulfilledAction } from '../../../domains/deleteMessage/actions.types';
import { DeleteThreadFulfilledAction } from '../../../domains/deleteThread/actions.types';
import {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../../domains/feedLoad/actions.types';
import {
  ThreadPinToUserStorylineFeedFulfilledAction,
  ThreadUnpinFromUserStorylineFeedFulfilledAction,
} from '../../../domains/pinnedThreads/actions.types';
import { ThreadMoveCompletedAction } from '../../../domains/threadMove/actions.types';
import {
  removeThreadFromAnyPinnedInstance,
  removeThreadFromAnyPinnedInstanceIfDeleted,
} from '../removeDeletedPinnedThread';
import { ThreadsPinnedToFeeds } from '../types';

export type ThreadsPinnedToUserStorylineFeedsAction =
  | DeleteMessageFulfilledAction
  | DeleteThreadFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | ThreadMoveCompletedAction
  | ThreadPinToUserStorylineFeedFulfilledAction
  | ThreadUnpinFromUserStorylineFeedFulfilledAction;

const initialState: ThreadsPinnedToFeeds = {};

const reducer: Reducer<ThreadsPinnedToFeeds, ThreadsPinnedToUserStorylineFeedsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToUserStorylineFeeds);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToUserStorylineFeeds);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToUserStorylineFeeds);
    case 'THREAD.PIN_TO_USER_STORYLINE_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToUserStorylineFeeds);
    case 'THREAD.UNPIN_FROM_USER_STORYLINE_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToUserStorylineFeeds);
    case 'MESSAGE.DELETE_FULFILLED':
      return removeThreadFromAnyPinnedInstanceIfDeleted(
        state,
        action.payload.threadId,
        action.payload.deletionOutcome === MessageDeletionOutcome.THREAD_REMOVED
      );
    case 'THREAD.DELETE_FULFILLED':
      return removeThreadFromAnyPinnedInstance(state, action.payload.threadId);
    case 'THREAD.MOVE_COMPLETED':
      return removeThreadFromAnyPinnedInstance(state, action.payload.threadId);
    default:
      return state;
  }
};

export default reducer;
